mutation ReplaceApproverApprovals($input: ReplaceApproverApprovalsInput!) {
  replaceApproverApprovals(input: $input) {
    clientMutationId
    processRequests {
      id
      rowTimestamp
      reference
      message
      isWarning
      isSuccess
      isFail
    }
  }
}
